import gql from "graphql-tag";
const getFitQuery = gql(` 
query GetFit($params: AWSJSON!) {
  getFit(params: $params) {
    id
    quantity
    filtered
    result
  }
}
`)
export default getFitQuery;